var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpDown = function SvgArrowUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21 16-4 4-4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20V4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m3 8 4-4 4 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4v16"
  }))));
};
export default SvgArrowUpDown;